import React from 'react'
import {HomeNavBar} from "../components/NavBar";
import Homepage from "../pages/Homepage";
import AboutUsPage from "../pages/AboutUsPage";
import LatestBlogsPage from "../pages/LatestBlogsPage";
import MapPage from "../pages/MapPage";
import SnackbarNotification from "../components/SnackbarNotification";

const MainPage = () => {
  return (
    <>
      {/* <MapTryout/> */}
      <HomeNavBar/>
      <Homepage />
      <AboutUsPage/>
      <LatestBlogsPage/>
      <MapPage/>
      <SnackbarNotification/>
    </>
  )
}

export default MainPage
